export default "__VITE_ASSET__Tg8gqcCD__"